import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class LoadScripts {

  loadScript(dynamicScripts: string) {

    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes(dynamicScripts)) {
        isFound = true;
      }
    }

    if (!isFound) {
      let node = document.createElement('script');
      node.src = dynamicScripts;
      node.type = 'text/javascript';
      node.async = false;
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
